// src/redux/sessionMaster/sessionMasterSelectors.js

// ✅ Add Session Master Selectors
export const selectAddSessionMasterData = (state) => state?.sessionMaster?.addSessionMaster?.data;
export const selectAddSessionMasterLoading = (state) => state?.sessionMaster?.addSessionMaster?.loading;
export const selectAddSessionMasterError = (state) => state?.sessionMaster?.addSessionMaster?.error;

// ✅ Update Session Master Selectors
export const selectUpdateSessionMasterData = (state) => state?.sessionMaster?.updateSessionMaster?.data;
export const selectUpdateSessionMasterLoading = (state) => state?.sessionMaster?.updateSessionMaster?.loading;
export const selectUpdateSessionMasterError = (state) => state?.sessionMaster?.updateSessionMaster?.error;

// ✅ Session Master List Selectors
export const selectSessionMasterList = (state) => state?.sessionMaster?.getSessionMasterList?.data || [];
export const selectSessionMasterListLoading = (state) => state?.sessionMaster?.getSessionMasterList?.loading;
export const selectSessionMasterListError = (state) => state?.sessionMaster?.getSessionMasterList?.error;
export const selectSessionMasterListTotal = (state) => state?.sessionMaster?.getSessionMasterList?.total || 0;

// ✅ Session Master Detail Selectors
export const selectSessionMasterDetail = (state) => state?.sessionMaster?.getSessionMasterDetail?.data;
export const selectSessionMasterDetailLoading = (state) => state?.sessionMaster?.getSessionMasterDetail?.loading;
export const selectSessionMasterDetailError = (state) => state?.sessionMaster?.getSessionMasterDetail?.error;

// ✅ Archive Session Master Selectors (Updated from delete)
export const selectArchiveSessionMaster = (state) => state?.sessionMaster?.archiveSessionMaster?.data;
export const selectArchiveSessionMasterLoading = (state) => state?.sessionMaster?.archiveSessionMaster?.loading;
export const selectArchiveSessionMasterError = (state) => state?.sessionMaster?.archiveSessionMaster?.error;

// ✅ Tool List Selectors
export const selectToolListData = (state) => state?.sessionMaster?.toolList?.data || [];
export const selectToolListLoading = (state) => state?.sessionMaster?.toolList?.loading;
export const selectToolListError = (state) => state?.sessionMaster?.toolList?.error;

// ✅ Complete Session Master State
export const selectSessionMasterState = (state) => state?.sessionMaster;